import getTBWStore from "../../stores/tbw-store";
import ET3Div from "../et3-div";
import { withLiteObserverAndTheme } from "../et3-enhanced-render";
import AlertTBWPopupHeader from "./alert-tbw-pop-up-header";
import CustomAlert from "./custom-alert";

const Et3TBWPopUp = withLiteObserverAndTheme((props) => {
  const shouldShow = getTBWStore().isTBWPopUpVisible.get();
  const { theme } = props;
  const { colors } = theme;

  return shouldShow ? (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={1400}
      height={1080}
      fDirection="row"
      alignItems="center"
      justifyContent="center"
      color={colors.all.transparent}
      style={{
        position: "fixed",
        top: 0,
        zIndex: 5
      }}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={true}
        fDirection="column"
        justifyContent="space-between"
        alignItems="center"
        withShadow={true}
        width={1000}
        height={300}
        color={colors.all.white}
        style={{
          position: "relative",
          borderRadius: 50,
          zIndex: 5
        }}
        onClick={() => {}}
      >
        <AlertTBWPopupHeader />
        <CustomAlert />
      </ET3Div>
    </ET3Div>
  ) : null;
});
export default Et3TBWPopUp;
